import { selectStyles } from 'apps/builder/components/shared'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import {
  tableCalculationSheetSelector,
  summaryEntriesSelector,
  builderTypeSelector,
} from 'apps/builder/store/selectors'
import { useEffect, useState } from 'react'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { calculationFormatOptions } from 'apps/builder/lib/utils'

export const SumSettings = ({
  guid,
  label,
  required,
  read_only,
  default: defaultValue,
  type,
  original_type_id,
  keyField,
  mask,
  summary_entry,
  style,
  selectedSheetId,
}) => {
  const tableCalculationSheets = useSelector(tableCalculationSheetSelector)
  const entries = useSelector(summaryEntriesSelector)
  const builderType = useSelector(builderTypeSelector)
  const dispatch = useDispatch()
  const [selectedSheet, setSelectedSheet] = useState(null)
  const { guid: summaryEntryGuid } = summary_entry || {}
  const selectedEntry =
    !selectedSheetId && entries.find(({ guid }) => summaryEntryGuid === guid)

  const screenOptions = tableCalculationSheets.map(
    ({ description, placeholder, id, subSheets }) => {
      return {
        label: description || placeholder,
        value: id,
        id,
        subSheets,
      }
    }
  )

  const hasError = screenOptions.length === 0
  const eligibleEntryFilter = entry => {
    const { sheet_id } = entry
    const { id = '', subSheets = [] } = selectedSheet || {}
    const sheetIds = [id, ...subSheets]
    return sheetIds.includes(sheet_id)
  }

  const entryOptions = entries
    .filter(eligibleEntryFilter)
    .map(({ label, guid }) => {
      return {
        label: label,
        value: guid,
      }
    })
    .filter(a => a)

  const formatOptions = calculationFormatOptions(builderType)
  const selectedFormat = formatOptions.find(({ value }) => value === style)

  useEffect(() => {
    if (selectedSheetId) {
      const selectedScreen = screenOptions.find(
        ({ value }) => value == selectedSheetId
      )

      return setSelectedSheet(selectedScreen)
    }

    if (selectedEntry) {
      const selectedScreen = screenOptions.find(({ id, subSheets }) => {
        const sheetIds = [id, ...subSheets]
        return sheetIds.includes(selectedEntry.sheet_id)
      })
      return setSelectedSheet(selectedScreen)
    }
  }, [selectedSheetId])

  return (
    <div className={`summary--settings ${hasError ? 'invalid' : ''}`}>
      <label className="settings--label">Sum up values in...</label>
      <div className="label-floating">
        <Select
          styles={selectStyles}
          classNamePrefix="react-select"
          className="summary--select input--placeholder"
          options={screenOptions}
          isDisabled={!screenOptions.length > 0}
          value={selectedSheet}
          onChange={({ value }) => {
            dispatch(
              updateEntry({
                guid: guid,
                selectedSheetId: value,
              })
            )
          }}
        />
        <label>Table</label>
      </div>

      <div className="label-floating">
        <Select
          styles={selectStyles}
          classNamePrefix="react-select"
          className="summary--select input--placeholder"
          isDisabled={!selectedSheet}
          options={entryOptions}
          value={selectedEntry}
          onChange={({ value }) => {
            dispatch(
              updateEntry({
                guid: guid,
                summary_entry: { guid: value },
                selectedSheetId: null,
              })
            )
          }}
        />
        <label>Column</label>
      </div>
      {hasError && (
        <div className="foundry--field-error">
          <div className="field-error--wrap">
            <i className="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
            <span className="field-error--message">
              To use Sum, you must have a previous table that contains a number
              or a calculation column.
            </span>
          </div>
        </div>
      )}

      <div className="label-floating summary--format">
        <Select
          styles={selectStyles}
          classNamePrefix="react-select"
          className="input--placeholder"
          placeholder={`Column`}
          options={formatOptions}
          value={selectedFormat}
          onChange={({ value }) => {
            dispatch(
              updateEntry({
                guid: guid,
                style: value,
              })
            )
          }}
        />
        <label>Format</label>
      </div>
    </div>
  )
}
